<template>

  <b-modal
    id="add-simulation-construction-modal"
    :ok-title="$t('Add')"
    :title="$t('Add') + ' ' + typeConstructionText"
    ok-only
    centered
    ok-variant="primary"
    @ok="handleOk">

    <div class="row">

      <div class="col-md-8">
        <b-form-group
          :label="$t('simulationConstruction.Name')"
          class="medium-label mb-4"
          label-for="name-input">
          <b-form-input
            id="name-input"
            v-model="name"
            required
            type="text">
          </b-form-input>
        </b-form-group>
      </div>

      <div class="col-md-4">
        <b-form-group
          :label="$t('simulationConstruction.UniteConstruction')"
          class="medium-label mb-4"
          label-for="uniteConstruction-input">
          <b-form-select
            id="uniteConstruction-input"
            v-model="uniteConstruction"
            required>
            <option v-for="option in unitesConstruction" :value="option.value">
              {{ $t(option.text) }}
            </option>
          </b-form-select>
        </b-form-group>
      </div>

    </div>

  </b-modal>

</template>

<script>

export default {

  name: "AddSimulationConstructionModal",

  props: {
    simulation: {
      type: Object,
      default: null
    },
    simulationLot: {
      type: Object,
      default: null
    },
    typeConstruction: {
      type: Object,
      default: null
    },
    unitesConstruction: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      name: null,
      uniteConstruction: null
    }
  },

  computed: {

    typeConstructionText() {
      return this.typeConstruction ? this.$i18n.t(this.typeConstruction.text) : ''
    }

  },

  emits: ['didAddSimulationConstruction'],

  methods: {

    handleOk() {
      this.handleSubmit()
    },

    handleSubmit() {
      if (this.name != null && this.name.trim() !== '') {
        let simulationConstruction = {
          simulation: this.simulation,
          simulationLot: this.simulationLot,
          typeConstruction: this.typeConstruction,
          uniteConstruction: this.unitesConstruction.find((unite) => unite.value === this.uniteConstruction),
          name: this.name,
          surface: null,
          prixParM2: null
        }
        this.$emit('didAddSimulationConstruction', simulationConstruction)
      }
      this.resetModal()
      this.hideModal()
    },

    resetModal() {
      this.name = null
    },

    hideModal() {
      this.$bvModal.hide('add-simulation-construction-modal')
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/components/AddSimulationConstructionModal.vue